export const TIER_DEPOSITS = {
  trial: 0,
  bronze: 100,
  silver: 500,
  gold: 1000,
} as const

export const TIER_POLICY_REQUIREMENTS = {
  trial: ['auto', 'renters', 'homeowners'],
  bronze: ['auto', 'renters', 'homeowners'],
  silver: ['renters', 'homeowners'],
  gold: ['homeowners'],
} as const

export const TRIAL_DURATION_DAYS = 90

export const TRIAL_MEMBERSHIP_CAP = 10

export const RESTRICTED_STATES = ['AK', 'AL', 'WY', 'SD'] as const

export const RESTRICTED_STATE_NAMES: Record<typeof RESTRICTED_STATES[number], string> = {
  AK: 'Alaska',
  AL: 'Alabama',
  WY: 'Wyoming',
  SD: 'South Dakota',
}

export const DECIMAL_PRECISION = {

  USDC_DECIMALS: 6,
  CONVERSION_FACTOR: 1000000,

  CURRENCY_DECIMALS: 2,
  PERCENTAGE_DECIMALS: 2,
  APY_PERCENTAGE_DECIMALS: 4,

  SIMULATION_PERCENTAGE_DECIMALS: 1,
  BOOST_PERCENTAGE_DECIMALS: 0,
} as const

export const TIME_PERIODS = {
  DAYS_PER_YEAR: 365,
  MONTHS_PER_YEAR: 12,
} as const

export const CONTRIBUTED_DISPLAY_THRESHOLD = 1

export const FORMAT_TEMPLATES = {
  PERCENTAGE_SUFFIX: '%',
  USD_PREFIX: '$',
  FALLBACK_PERCENTAGE: '0%',
} as const
